import { Button, CommandMenu } from "@bleu.builders/ui";
import { Gavel, Plus } from "@icon-park/react";
import { QuestionMarkCircledIcon } from "@radix-ui/react-icons";
import { Newspaper, ScrollText, SquarePen } from "lucide-react";
import React from "react";

import {
  DialogTemplatedMessage,
  TemplateMessage,
} from "#/components/CreateEmailLink";
import { Link } from "#/components/Link";
import { useUser } from "#/contexts/UserContext";
import { UserPagePath } from "#/lib/pagesHelper";
import { client } from "#/utils/api-client";

const DashboardPage = () => {
  const { user } = useUser();

  const buttons = [
    {
      title: "Diagnóstico tributário",
      icon: <Plus theme="outline" size="20" className="mr-2" />,
      path: UserPagePath.DIAGNOSES,
    },
    {
      title: "Teses tributárias",
      icon: <Gavel theme="outline" size="20" className="mr-2" />,
      path: UserPagePath.THESES,
    },
    {
      title: "Monitoramento tributário",
      icon: <Newspaper size="20" className="mr-2" />,
      path: UserPagePath.NEWS_ARTICLES,
    },
  ];

  function Buttons() {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mx-auto text-center text-primary font-medium text-sm uppercase">
        {buttons.map((button, index) => (
          <Button key={index} variant="ghost" asChild>
            <Link
              external={button.openInNewTab}
              to={button.path}
              className="flex items-center justify-center"
            >
              {button.icon}
              {button.title}
            </Link>
          </Button>
        ))}
        <DialogTemplatedMessage
          template={TemplateMessage.DOUBT}
          firstName={user.first_name}
          email={user.email}
        >
          <Button variant="ghost">
            <QuestionMarkCircledIcon className="mr-2" width={20} height={20} />
            Tire dúvidas
          </Button>
        </DialogTemplatedMessage>
      </div>
    );
  }

  return (
    <div className="flex h-[80vh] items-center">
      <div className="m-auto px-10">
        <div className="flex-col flex space-y-10">
          <h1 className="text-center font-semibold text-5xl mb-2 font-title">
            O que você está buscando agora?
          </h1>

          <div>
            <CommandMenu
              usePopover
              openInNewTab
              enableGlobalShortcut={false}
              placeholder="Busque por palavras-chave..."
              className="border rounded-md"
              fetcher={async (query) =>
                await client(`/global_search?q=${query}`)
              }
              icons={{
                NewsArticle: Newspaper,
                Thesis: ScrollText,
                PetitionModel: SquarePen,
              }}
            />
          </div>

          <Buttons />
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
